export default __webpack_public_path__ + "static/media/speed-2_w.e162930e.svg";